import Vue from 'vue'
import Vuex from 'vuex'
import SystemMenu from './modules/systemPower'
import user from './modules/user'
import config from './modules/config'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const userPaths = [
]

export default new Vuex.Store({
  state: {
    loading: false
  },
  mutations: {
    updateLoading (state, data) {
      state.loading = data
    }
  },
  actions: {
  },
  getters: {
    loading: state => state.loading,
    lang: state => state.user.language,
    regionCode: state => state.user.regionCode,
    mobilePrefixList: state => state.config.mobilePrefixList,
    externalParam: state => state.user.externalParam,
    registerParam: state => state.user.registerParam,
    resetPwdParam: state => state.user.resetPwdParam,
    selectMobileRegionCode: state => state.user.selectMobileRegionCode,
    baseUrl: state => state.config.baseUrl,
    manulRegionCode: state => state.config.manulRegionCode,
    finalRegionCode: state => state.config.manulRegionCode || state.user.regionCode,
    canSwitchRegion: state => state.config.canSwitchRegion,
    openRegionList: state => state.config.openRegionList
  },
  modules: {
    SystemMenu,
    user,
    config
  },
  plugins: [createPersistedState({
    paths: [
      ...userPaths
    ]
  })]
})
